export const ACTIVATE_PERSISTENT_LOGIN_POPUP = 'ACTIVATE_PERSISTENT_LOGIN_POPUP';
export const ADD_FREQUENT_FLYER_NUMBER = 'ADD_FREQUENT_FLYER_NUMBER';
export const AIRPORTS = 'AIRPORTS';
export const ANCILLARIES = 'ANCILLARIES';
export const ANCILLARY = 'ANCILLARY';
export const COUNTRIES = 'COUNTRIES';
export const CONTROL_PANEL = 'CONTROL_PANEL';
export const DEEP_LINK_ANCILLARY = 'DEEP_LINK_ANCILLARY';
export const DEEP_LINK_SEATS = 'DEEP_LINK_SEATS';
export const DISABLE_PERSISTENT_LOGIN_POPUP = 'DISABLE_PERSISTENT_LOGIN_POPUP';
export const INITIAL_CONFIRMATION_MODEL = 'INITIAL_CONFIRMATION_MODEL';
export const INTERACTION_STUDIO = 'INTERACTION_STUDIO';
export const LANGUAGE_BUNDLE = 'LANGUAGE_BUNDLE';
export const PUT_TIME_API = 'PUT_TIME_API';
export const RELOAD_BAGGAGE_FLAG = 'RELOAD_BAGGAGE_FLAG';
export const REMOVE_ANCILLARY_FROM_TRAVELERS = 'REMOVE_ANCILLARY_FROM_TRAVELERS';
export const REMOVE_ANCILLARY_PI_FROM_TRAVELERS = 'REMOVE_ANCILLARY_PI_FROM_TRAVELERS';
export const RESET_CP_NUMBER = 'RESET_CP_NUMBER';
export const RESET_LOGIN_SUCCESS_COUNT = 'RESET_LOGIN_SUCCESS_COUNT';
export const SET_SIGN_IN_STATE = 'SET_SIGN_IN_STATE';
export const STORE_FRONTS = 'STORE_FRONTS';
export const UPDATE_STATE_FARE_LOCK = 'UPDATE_STATE_FARE_LOCK';
export const WAS_ON_HOLD = 'WAS_ON_HOLD';